import { render, staticRenderFns } from "./RideTypeLuggagePassengerForm.vue?vue&type=template&id=590ed99c&scoped=true&"
import script from "./RideTypeLuggagePassengerForm.vue?vue&type=script&lang=js&"
export * from "./RideTypeLuggagePassengerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ed99c",
  null
  
)

export default component.exports